var render = function render(){var _vm=this,_c=_vm._self._c;return _c('child-icon',{style:({ fontSize: '16px' })})
}
var staticRenderFns = []

export { render, staticRenderFns }